import React from 'react';

import Avatar from '@atlaskit/avatar/avatar';

const AvatarStatusWarningExample = (): React.JSX.Element => {
	return <Avatar name="John Smith" status="warning" />;
};

export default AvatarStatusWarningExample;
